const companies = [
  {
    slug: "ocean-peace",
    name: "Ocean Peace",
    blurb: "Sustainably harvested wild-caught seafood",
    summary:
      "Ocean Peace, Inc. is one of the largest commercial fishing companies in the United States,  operating a fleet of vessels in the North Pacific and Bering Sea.  With a commitment to the science of sustainability,  it is a leading harvester and at-sea-processor of premium wild-caught Alaskan whitefish.  It is an Amendment 80 company.",
    url: "https://www.oceanpeaceinc.com/",
    logo: "/logos/op-logo-quality.png",
    photo: "/images/oceanpeace.jpg",
    photos: ["/images/OP-fleet-bg.webp", "/images/op-seafisher.webp", "/images/op-alaska-victory.webp", "/images/op-alaska-warrior.webp", "/images/op-bering-hope.webp"],
    backgroundImage: "/images/OP-fleet-bg.webp", // Test: Soft ocean waves or net pattern, desaturated
    backgroundPosition: "center",
  },
  {
    slug: "new-yorker",
    name: "The New Yorker Hotel",
    blurb: "Historic Manhattan stay since 1930",
    summary:
      "Opened in 1930, the New Yorker Hotel is an iconic Art Deco landmark in Midtown Manhattan. Just steps from Penn Station and Madison Square Garden, the hotel blends historic charm with modern comfort, welcoming guests to the heart of New York City.",
    url: "https://www.newyorkerhotel.com/",
    logo: "/logos/new-yorker-logo-red.png",
    photo: "/images/nyh.jpg",
    photos: ["/images/nyh-skyline.webp", "/images/nyh-grand-ballroom.webp", "/images/nyh-lobby.webp", "/images/nyh-crystal-ballroom.webp", "/images/nyh-butch-banker.webp", "/images/new-yorker-building.webp"],
    backgroundImage: "/images/new-yorker-bg.webp", // Test: Faint Art Deco pattern or NYC skyline desat
    backgroundPosition: "top",
  },
  {
    slug: "washington-times",
    name: "The Washington Times",
    blurb: "Trusted news from the nation’s capital",
    summary:
      "Founded in 1982, The Washington Times is a daily newspaper based in the nation’s capital. Known for its coverage of politics, national affairs, and world events, it provides readers with in-depth reporting and analysis from Washington, D.C.",
    url: "https://www.washingtontimes.com/",
    logo: "/logos/twt-logo-red-stack-no-bg.webp",
    photo: "/images/twt-building-1.jpg",
    photos: ["/images/twt-building-1.jpg", "/images/twt_building_front.jpg", "/images/twt-building-sign.webp", "images/twt-trump-article.webp"],
    backgroundImage: "/images/twt-building-bg.webp", // Test: Subtle newsprint texture or DC monument fade
    backgroundPosition: "center",
  },
  {
    slug: "manhattan-center",
    name: "Manhattan Center",
    blurb: "Iconic New York stage and studio",
    summary:
      "The Manhattan Center is a historic New York City venue that houses the Hammerstein Ballroom and Grand Ballroom. Renowned for hosting world-class concerts, television productions, and live events, it blends timeless architecture with cutting-edge production capabilities in the heart of Midtown Manhattan.",
    url: "https://www.themanhattancenter.com/",
    logo: "/logos/logo-manhattan-center.png",
    photo: "/images/MC-outside-photo.jpg",
    photos: ["/images/mc_front_night.jpg", "/images/mc_grand.jpg", "/images/mc_ballroom_set.png", "/images/mc_studio.jpg", "/images/MC-outside-photo.jpg"],
    backgroundImage: "/images/manhattan-center-bg.webp", // Test: Faint stage lights or venue silhouette
    backgroundPosition: "bottom 20%",
  },
];
export default companies;